var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileCsv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.4322 17.0159c-0.2467 -0.7267 -1.0144 -1.2473 -1.7967 -1.2473 -0.9548 0 -1.7966 0.8061 -1.7966 1.8005 0 0.7745 0.5062 1.4497 1.2277 1.6375l1.0151 0.2643c0.7937 0.2066 1.3505 0.9493 1.3505 1.8013v0.1095c0 1.0334 -0.8044 1.8711 -1.7967 1.8711 -0.7823 0 -1.55 -0.5207 -1.7966 -1.2474",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.5767 17.0159c-0.2466 -0.7267 -1.01438 -1.2473 -1.79665 -1.2473 -0.99226 0 -1.79665 0.8377 -1.79665 1.871v3.7421c0 1.0334 0.80439 1.8711 1.79665 1.8711 0.78227 0 1.55005 -0.5207 1.79665 -1.2474",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m23.2501 15.9351 -1.6147 6.7264c-0.0835 0.3477 -0.3835 0.5916 -0.7276 0.5916 -0.3442 0 -0.6442 -0.2439 -0.7276 -0.5916l-1.6148 -6.7264",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18 12.875V5.122c0.0001 -0.19702 -0.0386 -0.39212 -0.114 -0.57417 -0.0753 -0.18205 -0.1857 -0.34747 -0.325 -0.48683L14.689 1.19c-0.281 -0.281385 -0.6623 -0.43965 -1.06 -0.44H2.25c-0.39782 0 -0.77936 0.158035 -1.06066 0.43934C0.908035 1.47064 0.75 1.85218 0.75 2.25v17.5c0 0.3978 0.158035 0.7794 0.43934 1.0607 0.2813 0.2813 0.66284 0.4393 1.06066 0.4393h1.875",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.4512 0.75v4.62769h4.541",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCsv);
export default __webpack_public_path__ + "static/media/file-csv.f0a7657f48b4af4b6d953fdab78a538d.svg";
export { ForwardRef as ReactComponent };